import { useQuery } from '@tanstack/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { StorageKey } from '@/client/types'
import { getCustomerPaymentTypes, getTaxExemptLink, getUserInfos, updateUserInfos } from '@/infra/services'

export const useGetUserInfos = () => useQuery({
  queryKey: [StorageKey.USER_INFOS],
  queryFn: () => getUserInfos()
})

export const useMutateUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: {}) => updateUserInfos(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [StorageKey.USER_INFOS] })
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: [StorageKey.USER_INFOS] })
    }
  })
}

export const useGetCustomerPaymentTypes = (customerId: string, token: string, currency: string) =>
  useQuery({
    queryKey: [StorageKey.PAYMENT_TYPES, customerId],
    queryFn: () => getCustomerPaymentTypes(customerId!, token!, currency!),
    enabled: !!customerId && !!token && !!currency,
    staleTime: Infinity,
    refetchOnWindowFocus: false
  })

export const useGetTaxExemptLink = (customerId: string) =>
  useQuery({
    queryKey: [StorageKey.EXEMPT_LINK, customerId],
    queryFn: () => getTaxExemptLink(customerId!),
    enabled: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false
  })
